import React, { Fragment, useState } from 'react';
import GAButton from 'components/GAButton';
import api from 'constants/api';
import axios from 'helpers/axios';
import LuxityLoader from 'components/LuxityLoader';
import { error as notifyError } from '@bonlineza/luxity-lib/Notify';
import requestErrorMessages from 'constants/requestErrorMessages';

export default function Index({ sale_id, profile, sale_outstanding_amount }) {
  const [isLoading, setIsLoading] = useState(false);
  const availableCustomerCredit = profile.customer_credits || 0;
  const usableCustomerCredit =
    availableCustomerCredit > sale_outstanding_amount
      ? sale_outstanding_amount
      : availableCustomerCredit;

  const isPaymentDisabled = () => {
    return !availableCustomerCredit || availableCustomerCredit <= 0;
  };

  const handleClick = () => {
    setIsLoading(true);
    axios
      .post(api.data.PAY_WITH_CREDIT, {
        sale_id,
        credit_total: usableCustomerCredit,
      })
      .then((response) => {
        const { sale_order_number, amount } = response.data.payload;
        window.location.href = `/credit-payment-result?sale_order_number=${
          sale_order_number || ''
        }&amount=${amount || ''}`;
      })
      .catch(() => {
        notifyError(requestErrorMessages.RESPONSE_500);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const makePaymentButton = () => {
    return isLoading ? (
      <LuxityLoader />
    ) : (
      <GAButton
        className="btn--luxity make-payment-button"
        label="Make Credit Payment"
        disabled={isPaymentDisabled()}
        onClick={(e) => {
          e.preventDefault();
          handleClick();
        }}>
        MAKE PAYMENT USING CREDIT
      </GAButton>
    );
  };

  return (
    <Fragment>
      <div className="accordion-container payment-accordion">
        <div className="payment-field-card">
          <div className="payment-field-card__row payment-field-card__row--mobile-stack">
            <div className="payment-field-card__copy">
              <div className="payment-field-card__label">Use My Credit</div>
              <div className="payment-field-card__hint">
                {`Apply R${usableCustomerCredit.toLocaleString()} now (available: R${availableCustomerCredit.toLocaleString()}).`}
              </div>
            </div>
            <div className="payment-field-card__cta">{makePaymentButton()}</div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
